import React, { useContext, useEffect, useReducer, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
//import {NavLink} from 'react-router-dom';
import { Button, Badge, Dropdown } from 'react-bootstrap';

import DateRangePicker from "react-bootstrap-daterangepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";

//Import Components
import { ThemeContext } from "../../context/ThemeContext";
//import MorrisDonught from './Dashboard/MorrisDonught';
// import OrderForm from './Dashboard/OrderForm';
//import ServerStatusBar from './Dashboard/ServerStatusBar';
//import {LtcIcon, BtcIcon, XtzIcon, EthIcon} from './SvgIcon';

import avatar1 from "../../images/avatar/1.jpg";
import avatar2 from "../../images/avatar/2.jpg";
import avatar3 from "../../images/avatar/3.jpg";
const options = [
	{ value: "Party name", label: "Party name" },
	{ value: "Party Name", label: "Party name" },
	{ value: "Party name", label: "Party name" },
];
const types = [
	{ value: "Buy", label: "Buy" },
	{ value: "Sell", label: "Sell" },
	{ value: "Payment", label: "Payment" },
];

const listData = [
	{},
	{},
	{},
	{},
	{},
	{},
	{},
	{},
	{},
	{},
	{},
];
const tableData = [
	{ number: '1', item: 'Item', bqty: '10000', bamt: '1000000000', sqty: '10000', samt: '1000000000', bcr: '10000000', bdr: '100000000', statusColor: 'label-success' },
	{ number: '2', item: 'Item', bqty: '10000', bamt: '1000000000', sqty: '10000', samt: '1000000000', bcr: '10000000', bdr: '100000000', statusColor: 'label-success' },
	{ number: '3', item: 'Item', bqty: '10000', bamt: '1000000000', sqty: '10000', samt: '1000000000', bcr: '10000000', bdr: '100000000', statusColor: 'label-success' },
	{ number: '4', item: 'Item', bqty: '10000', bamt: '1000000000', sqty: '10000', samt: '1000000000', bcr: '10000000', bdr: '100000000', statusColor: 'label-success' },
	{ number: '5', item: 'Item', bqty: '10000', bamt: '1000000000', sqty: '10000', samt: '1000000000', bcr: '10000000', bdr: '100000000', statusColor: 'label-success' },
	{ number: '6', item: 'Item', bqty: '10000', bamt: '1000000000', sqty: '10000', samt: '1000000000', bcr: '10000000', bdr: '100000000', statusColor: 'label-success' },
	{ number: '7', item: 'Item', bqty: '10000', bamt: '1000000000', sqty: '10000', samt: '1000000000', bcr: '10000000', bdr: '100000000', statusColor: 'label-success' },

];

const PartyLedger = () => {
	const { changeBackground } = useContext(ThemeContext);
	useEffect(() => {
		changeBackground({ value: "dark", label: "Dark" });
	}, []);
	const [selectedOption, setSelectedOption] = useState(null);
	const [data, setData] = useState(
		document.querySelectorAll("#history_wrapper tbody tr")
	);
	const sort = 10;
	const activePag = useRef(0);
	const [test, settest] = useState(0);

	// Active data
	const chageData = (frist, sec) => {
		for (var i = 0; i < data.length; ++i) {
			if (i >= frist && i < sec) {
				data[i].classList.remove("d-none");
			} else {
				data[i].classList.add("d-none");
			}
		}
	};

	const chackbox = document.querySelectorAll(".bs_exam_topper input");
	const motherChackBox = document.querySelector(".bs_exam_topper_all input");
	const chackboxFun = (type) => {
		for (let i = 0; i < chackbox.length; i++) {
			const element = chackbox[i];
			if (type === "all") {
				if (motherChackBox.checked) {
					element.checked = true;
				} else {
					element.checked = false;
				}
			} else {
				if (!element.checked) {
					motherChackBox.checked = false;
					break;
				} else {
					motherChackBox.checked = true;
				}
			}
		}
	};

	// use effect
	useEffect(() => {
		setData(document.querySelectorAll("#history_wrapper tbody tr"));
		//chackboxFun();
	}, [test]);


	return (
		<>
			<div className="row">
				<div className="col-xl-12">
					<div className="row">
						<div className="col-xl-12 col-sm-6">
							<div className="card h-auto">
								<div className="card-body px-0 pt-1">
									<div className="sell-element">
										<form>
											<div className="row">
												<div className="col-md-3 mb-3">
													<div className="example rangeDatePicker">
														<label className="form-label text-primary">Date</label>
														<DateRangePicker
															initialSettings={{ startDate: '10/5/2022', endDate: '3/6/2022' }}
														>
															<input type="text" className="form-control input-daterange-timepicker" />
														</DateRangePicker>
													</div>
												</div>
												<div className="col-md-7 mb-3">
													<div className="example rangeDatePicker">
														<label className="form-label text-primary">Select Party</label>
														<Select
															options={options}
															defaultValue={options[0]}
															className="custom-react-select ms-2"
														/>
													</div>
												</div>
												<div className="col-md-2 mb-3">
													<div className="text-center">
														<label className="form-label text-primary"></label><br />
														<Link to={"/exchange"} className="btn btn-primary w-75">Submit</Link>
													</div>
												</div>
											</div>
											{/* <div className="text-center">
											<Button className="me-2" variant="primary">
											Primary
											</Button>
										</div>
											*/}
										</form>
									</div>
								</div>
							</div>
						</div>
						<div className="col-xl-12">
							<div className="row">
								<div className="col-xl-12 col-lg-12">
									<div className="card">
										<div className="card-header justify-content-between border-0">
											<h2 className="heading mb-0">Ledger</h2>
											<div className="toolbar" role="toolbar">
												<div className="btn-group mb-1">
													<button type="button" className="btn btn-danger light px-3">
														<i className="fa fa-times"></i>
													</button>
													<button type="button" className="btn btn-danger light px-3">
														<i className="fa fa-trash"></i>
													</button>
													<button type="button" className="btn btn-primary light px-3">
														<i className="fa fa-print"></i>
													</button>
													<button type="button" className="btn btn-primary light px-3">
														<i className="fa fa-share"></i>
													</button>
												</div>
												{/* <Dropdown className="btn-group mb-1">
												<Dropdown.Toggle
												type="button"
												className="btn btn-primary light dropdown-toggle px-3 ms-1"
												data-toggle="dropdown"
												>
												<i className="fa fa-folder me-1"></i>
												<b className="caret m-l-5"></b>
												</Dropdown.Toggle>
												<Dropdown.Menu className="dropdown-menu">
												<Dropdown.Item
													as="a"
													className="dropdown-item"
													to="/email-compose"
												>
													Social
												</Dropdown.Item>
												<Dropdown.Item
													as="a"
													className="dropdown-item"
													to="/email-compose"
												>
													Promotions
												</Dropdown.Item>
												<Dropdown.Item
													as="a"
													className="dropdown-item"
													to="/email-compose"
												>
													Updates
												</Dropdown.Item>
												<Dropdown.Item
													as="a"
													className="dropdown-item"
													to="/email-compose"
												>
													Forums
												</Dropdown.Item>
												</Dropdown.Menu>
											</Dropdown>
											<Dropdown className="btn-group mb-1">
												<Dropdown.Toggle
												className="btn btn-primary light dropdown-toggle px-3 ms-1"
												data-toggle="dropdown"
												>
												<i className="fa fa-tag me-1"></i>
												</Dropdown.Toggle>
												<Dropdown.Menu>
												<Dropdown.Item as="a">Updates</Dropdown.Item>
												<Dropdown.Item as="a">Social</Dropdown.Item>
												<Dropdown.Item as="a">Promotions</Dropdown.Item>
												<Dropdown.Item as="a">Forums</Dropdown.Item>
												</Dropdown.Menu>
											</Dropdown> */}

												{/* <Button
													type="button"
													className="btn btn-primary light ms-1"
												>
													<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
														<g clipPath="url(#clip0_732_458)">
															<path d="M23 19H18.93C18.6648 19 18.4104 18.8946 18.2229 18.7071C18.0354 18.5196 17.93 18.2652 17.93 18V15H6V18C6 18.2652 5.89464 18.5196 5.70711 18.7071C5.51957 18.8946 5.26522 19 5 19H1C0.734784 19 0.48043 18.8946 0.292893 18.7071C0.105357 18.5196 0 18.2652 0 18V8C0 7.20435 0.31607 6.44129 0.87868 5.87868C1.44129 5.31607 2.20435 5 3 5H21C21.7956 5 22.5587 5.31607 23.1213 5.87868C23.6839 6.44129 24 7.20435 24 8V18C24 18.2652 23.8946 18.5196 23.7071 18.7071C23.5196 18.8946 23.2652 19 23 19ZM19.93 17H22V8C22.0015 7.86827 21.9766 7.73757 21.9269 7.61558C21.8771 7.49359 21.8035 7.38276 21.7104 7.28961C21.6172 7.19646 21.5064 7.12285 21.3844 7.07312C21.2624 7.02339 21.1317 6.99853 21 7H3C2.86827 6.99853 2.73757 7.02339 2.61558 7.07312C2.49359 7.12285 2.38276 7.19646 2.28961 7.28961C2.19646 7.38276 2.12285 7.49359 2.07312 7.61558C2.02339 7.73757 1.99853 7.86827 2 8V17H4V14C4 13.7348 4.10536 13.4804 4.29289 13.2929C4.48043 13.1054 4.73478 13 5 13H18.93C19.1952 13 19.4496 13.1054 19.6371 13.2929C19.8246 13.4804 19.93 13.7348 19.93 14V17Z" fill="#ffffff" />
															<path d="M18.933 7H5C4.73478 7 4.48043 6.89464 4.29289 6.70711C4.10536 6.51957 4 6.26522 4 6V1C4 0.734784 4.10536 0.48043 4.29289 0.292893C4.48043 0.105357 4.73478 0 5 0L18.933 0C19.1982 0 19.4526 0.105357 19.6401 0.292893C19.8276 0.48043 19.933 0.734784 19.933 1V6C19.933 6.26522 19.8276 6.51957 19.6401 6.70711C19.4526 6.89464 19.1982 7 18.933 7ZM6 5H17.933V2H6V5ZM17.033 24H6.9C6.13087 24 5.39325 23.6945 4.84939 23.1506C4.30554 22.6068 4 21.8691 4 21.1V14C4 13.7348 4.10536 13.4804 4.29289 13.2929C4.48043 13.1054 4.73478 13 5 13H18.93C19.1952 13 19.4496 13.1054 19.6371 13.2929C19.8246 13.4804 19.93 13.7348 19.93 14V21.1C19.93 21.8686 19.6249 22.6058 19.0817 23.1495C18.5385 23.6933 17.8016 23.9992 17.033 24ZM6 15V21.1C6 21.3387 6.09482 21.5676 6.2636 21.7364C6.43239 21.9052 6.66131 22 6.9 22H17.033C17.2717 22 17.5006 21.9052 17.6694 21.7364C17.8382 21.5676 17.933 21.3387 17.933 21.1V15H6ZM20 10H19C18.7348 10 18.4804 9.89464 18.2929 9.70711C18.1054 9.51957 18 9.26522 18 9C18 8.73478 18.1054 8.48043 18.2929 8.29289C18.4804 8.10536 18.7348 8 19 8H20C20.2652 8 20.5196 8.10536 20.7071 8.29289C20.8946 8.48043 21 8.73478 21 9C21 9.26522 20.8946 9.51957 20.7071 9.70711C20.5196 9.89464 20.2652 10 20 10Z" fill="#ffffff" />
															<path d="M15 18H9C8.73478 18 8.48043 17.8946 8.29289 17.7071C8.10536 17.5196 8 17.2652 8 17C8 16.7348 8.10536 16.4804 8.29289 16.2929C8.48043 16.1054 8.73478 16 9 16H15C15.2652 16 15.5196 16.1054 15.7071 16.2929C15.8946 16.4804 16 16.7348 16 17C16 17.2652 15.8946 17.5196 15.7071 17.7071C15.5196 17.8946 15.2652 18 15 18ZM12 21H9C8.73478 21 8.48043 20.8946 8.29289 20.7071C8.10536 20.5196 8 20.2652 8 20C8 19.7348 8.10536 19.4804 8.29289 19.2929C8.48043 19.1054 8.73478 19 9 19H12C12.2652 19 12.5196 19.1054 12.7071 19.2929C12.8946 19.4804 13 19.7348 13 20C13 20.2652 12.8946 20.5196 12.7071 20.7071C12.5196 20.8946 12.2652 21 12 21Z" fill="#ffffff" />
														</g>
														<defs>
															<clipPath id="clip0_732_4581">
																<rect width="24" height="24" fill="white" />
															</clipPath>
														</defs>
													</svg>
												</Button> */}
											</div>
										</div>

										<div className="card-body px-0 py-0">
											<div className="table-responsive ">
												<table className="table border-0 mb-0 activity-tbl">
													<thead>
														<tr className="bg-pale-dark">
															<th className="text-center"># </th>
															<th><div className="form-check custom-checkbox checkbox-success check-lg me-3 bs_exam_topper_all">
																<input
																	type="checkbox"
																	className="form-check-input"
																	id="checkAll"
																	required=""
																	onClick={() => chackboxFun("all")}
																/>
																<label
																	className="form-check-label"
																	htmlFor="checkAll"
																></label>
															</div></th>
															<th className="text-center">Item Name</th>
															<th className="text-center">Purchase<br />
																<div className='row text-center'>
																	<div className='col-xl-6'>Qty</div>
																	<div className='col-xl-6'>Amt</div>
																</div>
															</th>
															<th className="text-center">Sell
																<div className='row text-center'>
																	<div className='col-xl-6'>Qty</div>
																	<div className='col-xl-6'>Amt</div>
																</div>
															</th>
															<th className="text-center">
																Balance
																<div className='row text-center'>
																	<div className='col-xl-6'>Cr.</div>
																	<div className='col-xl-6'>Dr.</div>
																</div>
															</th>
														</tr>
													</thead>
													<tbody>
														{tableData.map((item, ind) => (
															<tr key={ind}>
																<td className="text-center">
																	<Link to={"#"} className="text-primary">{item.number}</Link>
																</td>
																<td>
																	<div className="form-check custom-checkbox checkbox-success check-lg me-3 bs_exam_topper">
																		<input
																			type="checkbox"
																			className="form-check-input"
																			id="customCheckBox2"
																			required=""
																			onClick={() => chackboxFun()}
																		/>
																		<label
																			className="form-check-label"
																			htmlFor="customCheckBox2"
																		></label>
																	</div></td>
																<td className="text-center">{item.item}</td>
																<td>
																	<div className='row text-center'>
																		<div className='col-xl-6'>{item.bqty}</div>
																		<div className='col-xl-6'>{item.bamt}</div>
																	</div>
																</td>
																<td>
																	<div className='row text-center'>
																		<div className='col-xl-6'>{item.sqty}</div>
																		<div className='col-xl-6'>{item.samt}</div>
																	</div>
																</td>
																<td>
																	<div className='row text-center'>
																		<div className='col-xl-6'>
																			<Badge bg=" badge-lg " className='badge-success light'>{item.bcr}</Badge></div>
																		<div className='col-xl-6'><Badge bg=" badge-lg " className='badge-danger light'>{item.bdr}</Badge></div>
																	</div>
																</td>
															</tr>
														))}
														<tr style={{borderTop:"1px solid #fff"}}>
															<td></td>
															<td></td>
															<td className='text-center'><h4>Total :</h4></td>
															<td>
																<div className='row text-center'>
																	<div className='col-xl-6'><h4>50000000</h4></div>
																	<div className='col-xl-6'><h4>50000000</h4></div>
																</div>
															</td>
															<td>
																<div className='row text-center'>
																	<div className='col-xl-6'><h4>50000000</h4></div>
																	<div className='col-xl-6'><h4>50000000</h4></div>
																</div>
															</td>
															<td>
																<div className='row text-center'>
																	<div className='col-xl-6'><Badge bg=" badge-lg " className='badge-danger light'>50000000</Badge></div>
																	<div className='col-xl-6'><Badge bg=" badge-lg " className='badge-danger light'>50000000</Badge></div>
																</div>
															</td>
														</tr>
													</tbody>
												</table>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}
export default PartyLedger;